module.exports = __webpack_public_path__ + "img/15.2e97b09c.png";